import React from 'react';
import './ShopPromotion.css';
import { AnimatedSection } from '../../AnimatedSection';

const ShopPromotion = () => {
  return (
    <section className="shop-promotion section">
      <div className="container1">
        <div className="promotion-slider top-slider">
          <div className="slider-top-content">
            <img src="/home_data/section6/top/1.png" alt="Group 527" />
            <img src="/home_data/section6/top/2.png" alt="Group 527" />
            <img src="/home_data/section6/top/3.png" alt="Group 527" />
            <img src="/home_data/section6/top/4.png" alt="Group 527" />
            <img src="/home_data/section6/top/5.png" alt="Group 527" />
            <img src="/home_data/section6/top/6.png" alt="Group 527" />
            <img src="/home_data/section6/top/1.png" alt="Group 527" />
            <img src="/home_data/section6/top/2.png" alt="Group 527" />
            <img src="/home_data/section6/top/3.png" alt="Group 527" />
            <img src="/home_data/section6/top/4.png" alt="Group 527" />
            <img src="/home_data/section6/top/5.png" alt="Group 527" />
            <img src="/home_data/section6/top/6.png" alt="Group 527" />
          </div>
        </div>
        
          <div className="shop-content">
          <AnimatedSection><div className="shop-title">WHERE THE GAME  <br /> LIVES ON</div></AnimatedSection>

            <p style={{ maxWidth: '400px', margin: '0 auto', fontFamily: 'SimplonMonoMedium', marginTop: '30px' }}>
              {/* From clutch plays to daily grind, GAME 7 hooks you up with the gear and culture that keep you in the game. */}
            </p>
            <AnimatedSection><a target='_blank' href='https://www.amazon.com/stores/page/461F3B89-6764-45E0-9B2E-AB413358D21B?store_ref=storeRecs_sa__x&amp=&ref_=nb_sb_ss_w_stores-v2-t2_k0_2_11_1_1&crid=34HFD8HVB14P9&amp=&sprefix=game+7+appa&amp=&redirect_store_id=461F3B89-6764-45E0-9B2E-AB413358D21B' className="site-dft-btn">SHOP NOW</a></AnimatedSection>
          </div>
        
        <div className="promotion-slider bottom-slider">
          <div className="slider-bottom-content">
            <img src="/home_data/section6/bottom/1.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/2.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/3.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/4.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/5.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/6.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/1.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/2.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/3.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/4.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/5.png" alt="Group 527" />
            <img src="/home_data/section6/bottom/6.png" alt="Group 527" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default ShopPromotion;
